import { BankAccount } from '@modules/husleie-framework/src/types/BankAccount.entity';

const enum PaymentMethodEnum {
  SEPA = 'SEPA',
  MANUAL = 'MANUAL',
  STRIPE = 'STRIPE',
}
type PaymentMethodType = PaymentMethodEnum.SEPA | PaymentMethodEnum.MANUAL | PaymentMethodEnum.STRIPE;
type Stripe = {
  clientSecret: string;
  publicKey: string;
};
type PaymentMethodId = string;

interface Payment {
  method?: PaymentMethodType;
  bankAccount?: null | BankAccount;
  stripe?: null | Stripe;
}

export { PaymentMethodEnum, PaymentMethodType, Payment, PaymentMethodId, Stripe };
